// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	let	searchResultsNewWrapper  = document.querySelector('.search-results'),
	searchResultsNewWrapperMobile  = document.querySelector('.search-results-mobile'),
	screen = window.matchMedia('(max-width: 992px)');

	

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		if (screen.matches){
			
		}else{
			let searchResults  = document.getElementById('ui-id-1');
			searchResultsNewWrapper.appendChild(searchResults);
			searchResultsNewWrapper?.classList?.add("active");
		}
		
	};

	SearchInput.prototype.onOpenAutocomplete = function(){
			if (document.querySelector('li.boost-pfs-search-suggestion-group[data-group=suggestions] .boost-pfs-search-suggestion-header')){
				document.querySelector('li.boost-pfs-search-suggestion-group[data-group=suggestions] .boost-pfs-search-suggestion-header').textContent = 'Popular Search Terms';
				document.querySelector('li.boost-pfs-search-suggestion-group[data-group=products] .boost-pfs-search-suggestion-header').textContent = 'Popular Products';
			}
		if (screen.matches){
						
		}else{
			document.getElementById('ui-id-1').style.display = 'flex';
		}
		
	}
	
	SearchInput.prototype.render = function(){
		setTimeout(() => {
			if (screen.matches){
				let searchResultsMobile = document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel');
				searchResultsNewWrapperMobile.style.display = 'block';
				searchResultsMobile.querySelector('#boost-pfs-search-box-mobile').placeholder = 'Search for products or categories';
				searchResultsNewWrapperMobile.appendChild(searchResultsMobile);
				searchResultsNewWrapperMobile?.classList?.add("active");
			}
		}, 300);
	}
	
})();